import v20110510 from './20110510';
import v20110925 from './20110925';
import v20111031 from './20111031';
import v20120917 from './20120917';
import v20140805 from './20140805';

export default {
	20110510: v20110510,
	20110925: v20110925,
	20111031: v20111031,
	20120917: v20120917,
	20140805: v20140805
};
